module.exports = __webpack_public_path__ + "img/terms.3b7b1253.jpg";